import { render } from "./natureStudyMuseum.vue?vue&type=template&id=0444ea0b&scoped=true"
import script from "./natureStudyMuseum.vue?vue&type=script&lang=js"
export * from "./natureStudyMuseum.vue?vue&type=script&lang=js"

import "./natureStudyMuseum.vue?vue&type=style&index=0&id=0444ea0b&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0444ea0b"]])

export default __exports__